<ul *ngIf="pager.pages && pager.pages.length && items.length> pageSize" class="pagination">
    <!-- <li *ngIf="pager.totalPages > (pager.pageSize * 2)" [ngClass]="{disabled:pager.currentPage === 1}" class="page-item first-item">
        <a (click)="setPage(1)" class="page-link">αρχικη</a>
    </li> -->
    <li *ngIf="pager.totalPages > (pager.pageSize * 2) && pager.currentPage !== 1" class="page-item first-item">
        <a (click)="setPage(1)" class="page-link">αρχικη</a>
    </li>

    <!-- <li  *ngIf="pager.currentPage > 1" [ngClass]="{disabled:pager.currentPage === 1}" class="page-item previous-item">
        <a (click)="setPage(pager.currentPage - 1)" class="page-link">
            <<</a>
    </li> -->

    <li *ngIf="pager.currentPage !== 1" class="page-item previous-item">
        <a (click)="setPage(pager.currentPage - 1)" class="page-link">
            <<</a>
    </li>
    <li *ngIf="pager.currentPage > 5" [ngClass]="{disabled:pager.currentPage === 1}" class="page-item number-item">
        <a (click)="jumpBack(pager.currentPage)" class="page-link">...</a>
    </li>

    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}" class="page-item number-item">
        <a (click)="setPage(page)" class="page-link">{{page}}</a>
    </li>

    <li *ngIf="pager.currentPage < pager.totalPages && pager.totalPages > pager.pageSize" [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item number-item">
        <a (click)="jumpFront(pager.currentPage)" class="page-link">...</a>
    </li>
    <!-- <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item next-item">
        <a (click)="setPage(pager.currentPage + 1)" class="page-link"> >></a>
    </li>
    <li *ngIf="pager.totalPages > (pager.pageSize * 2)" [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item last-item">
        <a (click)="setPage(pager.totalPages)" class="page-link">Τελευταια</a>
    </li> -->

    <li *ngIf="pager.currentPage !== pager.totalPages" class="page-item next-item">
        <a (click)="setPage(pager.currentPage + 1)" class="page-link"> >></a>
    </li>
    <li *ngIf="pager.totalPages > (pager.pageSize * 2) && (pager.currentPage !== pager.totalPages)" [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item last-item">
        <a (click)="setPage(pager.totalPages)" class="page-link">Τελευταια</a>
    </li>
</ul>